import React from "react";
import { Dialog, DialogContent } from "./base/Dialog";
import {useLocalStorage} from "usehooks-ts";
import ACTLogo from "../assets/act_logo.svg?react";


export default function WelcomePopover({id, content}: {id: string | number, content: string}) {
  const [showWelcomeOnStart, setShowWelcomOnStart] = useLocalStorage(`showWelcome-${id}`, true);

  const [showWelcome, setShowWelcome] = React.useState(showWelcomeOnStart);
  if (!showWelcome) return null;
  return (
    <Dialog open={showWelcome} onOpenChange={() => setShowWelcome(false)}>
      <DialogContent>
        <div>
        <div className="flex flex-row items-center mb-4">
            <ACTLogo className="w-auto h-[30px]" />
        </div>
        <div dangerouslySetInnerHTML={{__html: content}} ></div>
        <div className="flex flex-col items-center mt-6 mb-1">
        <a href="#" className="underline y-4" onClick={() => { setShowWelcome(false); setShowWelcomOnStart(false) }}>Do not show again</a>
        </div>
        </div>
      </DialogContent>
    </Dialog> 
  );
}   
